import React from 'react';

const Icon = () => {
    return (
        <svg width="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 15.9C0 10.3938 0 7.64071 1.05455 5.53021C2.02249 3.59308 3.59308 2.02249 5.53021 1.05455C7.64071 0 10.3938 0 15.9 0H24.1C29.6062 0 32.3593 0 34.4698 1.05455C36.4069 2.02249 37.9775 3.59308 38.9454 5.53021C40 7.64071 40 10.3938 40 15.9V24.1C40 29.6062 40 32.3593 38.9454 34.4698C37.9775 36.4069 36.4069 37.9775 34.4698 38.9454C32.3593 40 29.6062 40 24.1 40H15.9C10.3938 40 7.64071 40 5.53021 38.9454C3.59308 37.9775 2.02249 36.4069 1.05455 34.4698C0 32.3593 0 29.6062 0 24.1V15.9Z"
                fill="#FAF6E0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.1642 22.8934C14.8395 22.8934 12 23.4015 12 25.4375C12 27.4726 14.8214 27.9999 18.1642 27.9999C21.489 27.9999 24.3285 27.491 24.3285 25.4559C24.3285 23.4208 21.5071 22.8934 18.1642 22.8934Z"
                stroke="#F8D600"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.1648 19.9899C20.3582 19.9899 22.1157 18.212 22.1157 15.995C22.1157 13.7771 20.3582 12 18.1648 12C15.9722 12 14.2139 13.7771 14.2139 15.995C14.2139 18.212 15.9722 19.9899 18.1648 19.9899Z"
                stroke="#F8D600"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.2313 17.1763V20.6832"
                stroke="#F8D600"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.0004 18.9296H24.4629"
                stroke="#F8D600"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
